export default __webpack_public_path__ + "static/media/girl.97b05e89.gif";